import React from "react";
import Banner from "../Menhome/Banner";
import Offer from "../Menhome/Offer";
import Story from "../Menhome/Story";
import Specialdish from "../Menhome/Specialdish";
import Menusection from "../Menhome/Menusection";
import Whyus from "../Menhome/Whyus";
import Special from "../Menhome/Special";
import Contact from "../Menhome/Contact";
import Videosection from "../Menhome/Videosection";

function Main() {
  return (
    <>
      <Banner />
      <Offer />
      <Story />
      <Specialdish />
      <Menusection />
      <Special />
      <Contact />
      <Whyus />
      <Videosection />
    </>
  );
}

export default Main;
